import TagManager from 'react-gtm-module';
import { useEffect, useState } from 'react';

const GTagManager = ({ user, GOOGLE_ANALYTICS_CONTAINER_ID }) => {

    const [ isGTMInitialize, setGTMInitialize ] = useState(false);

    const tagManagerArgs = {
        gtmId: GOOGLE_ANALYTICS_CONTAINER_ID,
        dataLayer: {
            'event': 'pageViewGI',
            'pageName' : document.title,
            'pageCategory': 'Dashboard',
            'referringPageUrl': document.referrer,
            'destinationPageUrl': document.URL, 
            'userSignin': '',
            'getInsuredTool': 'Portal',
            'caseID': '',
            'userRole': '',
            'userDetailedRole': '',
        }
    };

    const initializeGTM = (tagManagerArgs)=> {
        TagManager.initialize(tagManagerArgs);
        setGTMInitialize(true);
    };

    useEffect( () => {
        if (isGTMInitialize) return;

        if (user) {
            const { role, userActiveRole } = user;
            tagManagerArgs.dataLayer.userRole = role;
            tagManagerArgs.dataLayer.userDetailedRole = userActiveRole;
            tagManagerArgs.dataLayer.userSignin = 'Signed In';            
            initializeGTM(tagManagerArgs);
        } else {
            tagManagerArgs.dataLayer.userSignin = 'Not Signed In';
            initializeGTM(tagManagerArgs);     
        }
    }, [ user, isGTMInitialize ]);  

    return null;
};

export default GTagManager;